import React from 'react'
import { connect } from 'react-redux'
import StopInfoButton from '../../components/buttons/StopInfoButton'
import { forceMediaPause } from '../../../interactive-element/actions/common'
import { showStopDescriptionDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { setStopDescriptionOpen } from 'aria-viewer/stopselector/actions/stopDescriptionActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import compose from 'recompose/compose'

const additionalSceneDetailsNotAvailable = (supplementalMedia, point) => {
    // Determines if supplementalmedia or description is present.
    // Returns a boolean that is fed into hideInfoButton
    // Is false if either is present
    let descriptionPresent
    if (point && point.descriptions) {
        if (typeof point.descriptions == 'object') {
            descriptionPresent = !!Object.keys(point.descriptions).length
        } else {
            descriptionPresent = !!descriptionPresent
        }
    }

    const supplementalMediaPresent = supplementalMedia && !!supplementalMedia.stopid
    return !descriptionPresent && !supplementalMediaPresent
}

const mapStateToProps = state => {
    const { audioManager, point, supplementalMedia, isSingleMedia } = mapSelectorsToProps([
        'audioManager',
        'point',
        'supplementalMedia',
        'isSingleMedia',
    ])()(state)

    const audioIsPlaying = audioManager
        .get('state')
        .toArray()
        .includes('AUDIO_PLAY')

    const hideInfoButton = additionalSceneDetailsNotAvailable(supplementalMedia, point)

    return {
        audioIsPlaying,
        hideInfoButton,
        isSingleMedia,
    }
}

const mapDispatchToProps = dispatch => ({
    onClick: () => {
        dispatch(forceMediaPause(true))
        dispatch(showStopDescriptionDrawer())
        dispatch(setStopDescriptionOpen(true))
    },
})

const shouldRenderComponent = WrappedComponent => ({ isSingleMedia, ...props }) =>
    !isSingleMedia ? <WrappedComponent isSingleMedia={isSingleMedia} {...props} /> : null

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    shouldRenderComponent
)(StopInfoButton)
